import React from "react";
import { DatePicker as DatePickerMUI } from "material-ui-pickers";
import { DateUtils } from "shared/dateUtils";
import { useTranslations } from "adapters/i18n";
const DatePicker = (props) => {
  const { t } = useTranslations();
  const {
    className,
    onChangeDate,
    label,
    maxDateMessage,
    minDateMessage,
    value,
    maxDate,
    minDate,
    format,
    disableFuture,
    customStyle,
    id,
    clearable,
    okLabel = t("common:actions.select"),
    cancelLabel = t("common:actions.cancel"),
    clearLabel = t("common:actions.clear"),
    todayLabel = t("common:today"),
    showTodayButton = false,
    placeholder = "DD/MM/AAAA",
    keyboard = true,
    InputProps,
    onError,
    onChangeInputValue,
  } = props;
  const functionError = onError ? onError : () => {};
  const inputChange = onChangeInputValue ? onChangeInputValue : () => {};
  return (
    <DatePickerMUI
      id={id}
      format={format}
      minDate={minDate}
      onInputChange={(e) => {
        inputChange(e.target.value);
      }}
      maxDate={maxDate}
      onlyCalendar
      keyboard={keyboard}
      okLabel={okLabel}
      cancelLabel={cancelLabel}
      clearable={clearable}
      clearLabel={clearLabel}
      todayLabel={todayLabel}
      showTodayButton={showTodayButton}
      placeholder={placeholder}
      className={className}
      label={label}
      InputProps={InputProps}
      disableFuture={disableFuture}
      invalidDateMessage="O Formato da data é inválido"
      maxDateMessage={maxDateMessage}
      minDateMessage={minDateMessage}
      mask={(value) =>
        value ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/] : []
      }
      onError={(e, error) => functionError(e, error)}
      disableOpenOnEnter
      animateYearScrolling={false}
      value={value}
      onChange={(e) => {
        onChangeDate(e);
      }}
      style={
        !customStyle
          ? {
              width: 150,
            }
          : customStyle
      }
    />
  );
};

DatePicker.defaultProps = {
  disableFuture: true,
  maxDate: DateUtils.now(),
  minDate: DateUtils.now(),
  format: "DD/MM/YYYY",
};
export default DatePicker;
